export default __webpack_public_path__ + "static/media/6.26d2b2e3.JPG";